<template>
  <transaction-table-item
    class="payouts-to-card-table-item"
    v-if="type === 'transaction'"
    :transaction="transaction"
    :details-blocks="transaction.TRANSACTION_DETAIL_BLOCKS"
  >
    <template #shortInfo>
      <div class="transaction-table-item__col transaction-table-item__date">
        <div class="transaction-table-item__date-main">
          {{ transaction.transactionDate }}
        </div>
        <div class="transaction-table-item__date-time">
          {{ transaction.transactionTime }}
        </div>
      </div>
      <div class="transaction-table-item__col transaction-table-item__pt-id">
        {{ transaction.cardNumber }}
      </div>
      <div class="transaction-table-item__col transaction-table-item__pt-id">
        {{ transaction.partnerTransactionId }}
      </div>
      <div class="transaction-table-item__col transaction-table-item__op-id">
        {{ transaction.operationId }}
      </div>
      <div class="transaction-table-item__col transaction-table-item__client">
        <div class="transaction-table-item__client-full-name">
          {{ transaction.userFullName }}
        </div>
        <div class="transaction-table-item__client-phone">
          {{ transaction.userPhone }}
        </div>
        <div class="transaction-table-item__client-email">
          {{ transaction.userEmail }}
        </div>
      </div>
      <div class="transaction-table-item__col transaction-table-item__amount">
        {{ transaction.transactionAmount }}
        {{ transaction.transactionCurrency }}
      </div>
      <div class="transaction-table-item__col transaction-table-item__status">
        <transaction-status
          :status-id="transaction.operationStatus"
        ></transaction-status>
      </div>
      <transactions-table-actions-button
        class="transaction-table-item__col transaction-table-item__actions"
        :actions="itemActions"
        ref="actionsMenu"
        @actionFired="handleActionFired"
      >
      </transactions-table-actions-button>
    </template>
  </transaction-table-item>
  <div class="payouts-to-card-table-item" v-else>
    <div class="transaction-table-item">
      <div class="transaction-table-item__short-info">
        <div class="transaction-table-item__col transaction-table-item__date">
          <div class="transaction-table-item__date-main">
            {{ itemDateTime.date }}
          </div>
          <div class="transaction-table-item__date-time">
            {{ itemDateTime.time }}
          </div>
        </div>
        <div
          class="transaction-table-item__col transaction-table-item__card-number"
        >
          {{ itemPan }}
        </div>
        <div class="transaction-table-item__col transaction-table-item__pt-id">
          {{ '' }}
        </div>
        <div class="transaction-table-item__col transaction-table-item__op-id">
          {{ payoutsRegistryItem.operationID }}
        </div>
        <div class="transaction-table-item__col transaction-table-item__client">
          {{ fullName }}<br />
          {{ payoutsRegistryItem.ipn }}
        </div>
        <div class="transaction-table-item__col transaction-table-item__sum">
          {{ itemSum }}
        </div>

        <div class="transaction-table-item__col transaction-table-item__status">
          <transaction-status :status-id="status"></transaction-status>
        </div>

        <transactions-table-actions-button
          :actions="itemActions"
          ref="actionsMenu"
          @actionFired="handleActionFired"
        >
        </transactions-table-actions-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  $on,
  $off,
  $once,
  $emit,
} from '../../../../../../utils/gogocodeTransfer'
import TransactionStatus from '@vue-app/components/transaction/TransactionStatus.vue'
import { CompaniesApi } from '@js-app/office/api/companies-api'
import { RouteHelper } from '@js-app/services/helpers/routes/routes-helper'
import { mapState } from 'vuex'
import Loader from '@vue-app/components/base/Loader.vue'
import TransactionsTableActionsButton from '@vue-app/components/company/transactions/table/TransactionsTableActionsButton.vue'
import TextInput from '@vue-app/components/base/input/TextInput.vue'
import { ERROR } from '@js-app/const/operation-statuses-ids'
import moment from 'moment/moment'
import { addTrailingZeros } from '@js-app/services/helpers/math'
import TransactionTableItem from '@vue-app/components/company/transactions/table/TransactionsTableItem.vue'
import { Transaction } from '@js-app/entities/transaction/Transaction'

export default {
  name: 'PayoutsRegistryMainTableItem',
  components: {
    TransactionTableItem,
    TextInput,
    TransactionsTableActionsButton,
    Loader,
    TransactionStatus,
  },
  props: {
    payoutsRegistryItem: {
      type: Object,
    },
  },
  data() {
    return {
      isPayoutsRegistryItemUpdated: false,
      payoutsRegistryItemUpdated: {
        ...this.payoutsRegistryItem,
        sum: (parseInt(this.payoutsRegistryItem.sum) / 100).toFixed(2),
      },
    }
  },
  computed: {
    ...mapState(['selectedCompany']),
    type() {
      console.log(
        'blabalbal',
        this.payoutsRegistryItem.operationID === 0 ||
          this.payoutsRegistryItem.operationID === null ||
          this.payoutsRegistryItem.operation_status_id === 0
          ? 'default'
          : 'transaction'
      )

      return this.payoutsRegistryItem.operationID === 0 ||
        this.payoutsRegistryItem.operationID === null ||
        this.payoutsRegistryItem.operation_status_id === 0
        ? 'default'
        : 'transaction'
    },
    transaction() {
      return new Transaction(this.payoutsRegistryItem.pos_analytics)
    },
    itemActions() {
      let _actions = []

      if (this.payoutsRegistryItem.operation_status_id === ERROR) {
        _actions.push({
          id: 'repeat-payout',
          title: this.$t('transaction-actions.repeat-payout'),
          handler: this.repeatPayout,
        })
      }

      return _actions
    },
    itemDateTime() {
      return {
        date: moment(this.payoutsRegistryItem.date_update).format('DD.MM.YYYY'),
        time: moment(this.payoutsRegistryItem.date_update).format('HH:mm:ss'),
      }
    },
    itemPan() {
      return `${this.payoutsRegistryItem.pan.substring(
        0,
        6
      )}******${this.payoutsRegistryItem.pan.substring(
        12,
        this.payoutsRegistryItem.pan.length
      )}`
        .match(/.{1,4}/g)
        .join(' ')
    },
    itemSum() {
      return `${addTrailingZeros(
        (parseInt(this.payoutsRegistryItem.sum) / 100).toLocaleString()
      )} ₴`
    },
    status() {
      if (
        this.payoutsRegistryItem.status === 'new' &&
        this.payoutsRegistryItem.operation_status_id === 0
      ) {
        return 0
      }
      if (
        this.payoutsRegistryItem.status === 'error' &&
        this.payoutsRegistryItem.operation_status_id === 0
      ) {
        return ERROR
      }

      return this.payoutsRegistryItem.operation_status_id
    },
    fullName() {
      let _fullNameParts = this.payoutsRegistryItem.fio.split(' ')

      let _lastName = _fullNameParts[0] || ''

      if (_lastName.length > 2) {
        let _lastNameFirstChar = _lastName[0],
          _lastNameLastChar = _lastName[_lastName.length - 1]

        _lastName =
          _lastNameFirstChar +
          ''.padEnd(_lastName.length, '*') +
          _lastNameLastChar
      } else if (_lastName.length > 0 && _lastName.length <= 2) {
        let _lastNameFirstChar = _lastName[0]

        _lastName = _lastNameFirstChar + ''.padEnd(2, '*')
      }

      _fullNameParts[0] = _lastName

      return _fullNameParts.join(' ')
    },
  },
  methods: {
    async handleActionFired(action) {
      try {
        await action.handler()
      } catch (e) {
        console.error(e)
      }

      try {
        this.$refs.transactionItem.actionFinished(action.id)
      } catch (e) {}
    },
    async loadReceipt() {
      let receiptResponse = await CompaniesApi.getBillReceipt(
        this.selectedCompany,
        this.transaction.operationId
      )
      this.transactionReceiptBlob = URL.createObjectURL(receiptResponse.data)
      return this.$refs.transactionReceiptPopup.open()
    },
    toPayoutToCardDetails() {
      this.$router.push(
        RouteHelper.getRoute('payout-to-card-view', {
          companyId: this.selectedCompany,
          payoutId: this.transaction.operationId,
        })
      )
    },
    handleDeleteItem() {
      $emit(this, 'deleted', this.payoutsRegistryItem)
    },
    handleUpdatePayoutRegistryItem() {
      if (this.isPayoutsRegistryItemUpdated) {
        this.isPayoutsRegistryItemUpdated = false
        $emit(this, 'updated', this.payoutsRegistryItemUpdated)
      }
    },
    repeatPayout() {
      $emit(this, 'repeatPayout', this.payoutsRegistryItem)
      this.$refs.actionsMenu.actionFinished('repeat-payout')
    },
  },
  emits: ['deleted', 'updated', 'repeatPayout'],
}
</script>

<style lang="scss" scoped>
.payouts-to-card-table-item {
  .transaction-table-item {
    &__date {
      padding: 0;
    }

    &__name {
      word-break: break-all;
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;
      color: #1a1f29;
      opacity: 0.7;
    }

    &__amount,
    &__sum {
      font-weight: 600;
      font-size: 14px;
      line-height: 18px;
      color: #1a1f29;
      opacity: 0.7;
      justify-content: center;
    }

    &__commission {
      justify-content: center;
    }

    &__currency {
      justify-content: flex-end;
    }

    &__delete {
      justify-content: center;
    }

    &__status {
      align-self: center;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: 20px;
      padding-right: 20px;

      &-item {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 105px;
        max-width: 100%;
        height: 28px;
        border-radius: 6px;
        font-weight: 500;
        font-size: 12px;
        line-height: 28px;

        &--paid {
          background: rgba(39, 204, 36, 0.2);
          color: #44d941;
        }
      }
    }
  }
}
</style>
